<div class="card">
  <div class="card-body row align-items-center">
    <div class="col-6 col-sm-4">
      <small>Payment Schedule:</small>
      <br>
      <strong class="h5">{{ report.payment_schedule ? (report.payment_schedule | titlecase) : '—' }}</strong>
      <br>
      <small *ngIf="report.has_nexus" role="button"
             [routerLink]="countryNexusLink"
             [queryParams]="countryNexusQueryParams"
             ngbTooltip="Edit country nexus" class="mdi mdi-wrench text-info">
      </small>
    </div>

    <div class="col-sm-4 d-none d-sm-block text-center">
      <p *ngIf="!collecting" class="small">
        Expected Sales Tax Due
        <span class="mdi mdi-alert-circle text-warning"></span>
      </p>
      <p *ngIf="collecting" class="small">
        Actual Sales Tax Collected
        <span class="mdi mdi-check-circle text-success"></span>
      </p>

      <p>
        <app-amount [amount]="taxAmount"
                    class="h2 text-{{ collecting ? 'success' : 'warning' }}"></app-amount>
      </p>

      <a [routerLink]="salesReportLink"
         [queryParams]="{ start_date: startDate, end_date: endDate }"
         class="btn btn-xs btn-outline-{{ collecting ? 'success' : 'warning' }}" fragment="actual">
        <span class="mdi mdi-file-chart"></span>
        Sales Tax Report
      </a>
    </div>

    <div class="col-6 col-sm-4 text-center">
      <div class="row justify-content-center">
        <div class="d-flex flex-column align-items-center align-self-center">
          <p class="h4">{{ report.name }}</p>
          <small class="text-muted">{{ report.code }}</small>

          <div class="d-block d-sm-none mt-2">
            <p class="mb-1">
              <app-amount [amount]="taxAmount" class="h2 text-{{ collecting ? 'success' : 'warning' }}"></app-amount>
            </p>
            <a [routerLink]="salesReportLink"
               [queryParams]="{ start_date: startDate, end_date: endDate }"
               class="btn btn-xs btn-outline-{{ collecting ? 'success' : 'warning' }}" fragment="actual">
              <span class="mdi mdi-file-chart"></span>
              Sales Tax Report
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
